import React, {useCallback, useMemo, useState} from "react";
import {Field, useForm} from "react-final-form";
import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {
    UserTenthPassingYear,
    IdLabelInterface,
} from "../../../../containers/RegistrationLoginPage/types";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {UseComboboxState} from "downshift";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentClassField} from "../../../../containers/RegistrationLoginPage/actions";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
import {RootStore} from "../../../../configureStore";

interface TenthTwelthPassingYearInterface {
    configuration: UserTenthPassingYear;
}

const TenthTwelthPassingYear: React.FC<TenthTwelthPassingYearInterface> = ({
    configuration,
}: TenthTwelthPassingYearInterface) => {
    const {selectedValue, values, fieldName} = configuration;

    const form = useForm();
    const dispatch = useDispatch();
    const [dependentFields] = useState(() => ["tenthTwelfthPercentage"]);

    const currentClass = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields?.currentClass ?? "10",
    );

    const onChangeCallback = useCallback(
        (obj: Partial<UseComboboxState<IdLabelInterface>>) => {
            const selectedYear = obj.selectedItem?.id;
            const date = new Date();
            // calculate updated class
            const newClass = selectedYear && selectedYear <= date.getFullYear() - 2 ? "12" : "10";
            if (newClass !== currentClass) {
                // reset year dependent fields
                const registeredFields = form.getRegisteredFields();
                dependentFields.map((field) => {
                    if (registeredFields.includes(field)) {
                        form.resetFieldState(field);
                        form.change(field, null);
                    }
                });
                // update value in redux
                dispatch(setCurrentClassField(newClass));
            }
        },
        [dispatch, form, dependentFields, currentClass],
    );

    return useMemo(() => {
        return (
            <Field<IdLabelInterface>
                name={fieldName}
                validate={composeValidators(
                    regRequiredValidate("Please select class 10th passing year"),
                )}
                validateFields={dependentFields}
                {...(selectedValue ? {initialValue: selectedValue} : {})}
            >
                {(props) => {
                    return (
                        <SelectV2
                            placeholder={"Class 10th Passing Year"}
                            type={SINGLE_SELECT}
                            items={values ?? []}
                            inputRFF={props.input}
                            withSearch={false}
                            isFocused={props?.meta?.active ?? false}
                            isTouched={props?.meta?.touched}
                            error={errorHandler(props?.meta)}
                            selectedOption={selectedValue ? [selectedValue] : undefined}
                            onSelectedItemChange={onChangeCallback}
                            isFilled={typeof props.input.value === "object"}
                        />
                    );
                }}
            </Field>
        );
    }, [selectedValue, values, onChangeCallback, fieldName, dependentFields]);
};

export default TenthTwelthPassingYear;
